import { SensorLockerStatus } from '@frontend/device/types';
import { FormattedMessage } from 'react-intl';

import LargeSlotCard from '../../../components/slot-cards/large-slot-card.component';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { ProductCard } from '../browse-products-by-categories/product-card/product-card.component';
import useLendingReviewDetail from './lending-review-detail.controller';

const ID = 'lending-review-detail';

const LendingReviewDetail = () => {
    const viewProps = useLendingReviewDetail();

    return (
        <WizardScreenContainer
            id={ID}
            loadingModal={{
                show: viewProps.isProcessing
            }}
            footer={{
                onSubmit: viewProps.handleSubmit,
                submitDisabled: viewProps.isProcessing || !viewProps.slot,
                submitLabel: (
                    <FormattedMessage
                        id='kiosk.manage-spot.view-content-slot-detail.open-slot'
                        defaultMessage='Open SLOT {name}'
                        values={{ name: viewProps.slot?.display ?? '' }}
                    />
                )
            }}>
            <div className='flex flex-col items-start justify-start gap-3 self-stretch'>
                <div className='text-foreground-default justify-end'>
                    <FormattedMessage
                        defaultMessage='Selected product'
                        id='kiosk.wizard.lending-review-detail.selected-product'
                        description='Instruction text on the lending review detail screen, showing the selected product'
                    />
                </div>
                <ProductCard
                    product={viewProps.product}
                    equipment={viewProps.equipment}
                />
                {viewProps.slot && (
                    <LargeSlotCard
                        slot={viewProps.slot}
                        status={SensorLockerStatus.CLOSED}
                    />
                )}
            </div>
        </WizardScreenContainer>
    );
};

export default LendingReviewDetail;
